import React, { Component } from 'react';
import ReactToPrint from 'react-to-print';

import Tabs from './Tabs';
import { Col, Grid, Panel, PanelBody, PanelContainer, PanelHeader, Row } from '@sketchpixy/rubix';

class Calculator extends Component {
  constructor(props) {
    super(props);

    const form = {
      productPrice: 1732,
      productQnty: 1,
      numberOfPatients: 1,
      pt: 4,
    };

    const item01 = {
      code: 'G2061',
      price: 33.92,
    };

    const item02 = {
      code: '99454',
      price: 62.00,
    };

    this.state = {
      form,
      breakEven: {
        point: 0,
        items: [],
      },
      item01,
      item02,
      totalPrice: 0,
    };
  }

  initBreakEven = () => {
    let isFinish = false;
    let isFind = false;

    let items = [];
    let month = 3;
    let breakEvenPoint = month;
    let roi;

    const { form, breakEven, item01, item02 } = this.state;

    const totalPrice = (item01.price * form.pt * form.numberOfPatients) + (item02.price * form.numberOfPatients);

    while (!isFinish) {
      roi = (((month * totalPrice) / (form.productPrice * form.productQnty)) * 100).toFixed(0);

      items.push((
        <tr key={month} className={!isFind && roi > 100 ? 'point' : null}>
          <td>{month} months</td>
          <td>${(month * totalPrice).toFixed(2)}</td>
          <td>{roi}%</td>
        </tr>
      ));

      if (roi > 100 && !isFind) {
        isFind = true;
        breakEvenPoint = month;
      }

      if (isFind && month >= 12) {
        isFinish = true;
      }

      month = month + 3;
    }

    breakEven.point = breakEvenPoint;
    breakEven.items = items;

    this.setState({
      breakEven,
      totalPrice,
    });
  };

  componentDidMount() {
    this.initBreakEven();
  }

  changeForm = (event) => {
    const { form } = this.state;
    this.setState({
      form: {
        ...form,
        [event.target.name]: event.target.value,
      },
    }, () => {
      this.initBreakEven();
    });
  };

  increase = (event) => {
    const { form } = this.state;
    this.setState({
      form: {
        ...form,
        [event.target.name]: parseInt(form[event.target.name]) + 1,
      },
    }, () => {
      this.initBreakEven();
    });
  };

  decrease = (event) => {
    const { form } = this.state;
    if (form[event.target.name] !== 1)
      this.setState({
        form: {
          ...form,
          [event.target.name]: parseInt(form[event.target.name]) - 1,
        },
      }, () => {
        this.initBreakEven();
      });
  };

  render() {
    const { form, breakEven, item01, item02, totalPrice } = this.state;

    return (
      <PanelContainer controls={false}>
        <Panel>
          <PanelHeader>
            <Grid>
              <Row>
                <Col xs={12}>
                  <h3>Calculator</h3>
                </Col>
              </Row>
            </Grid>
          </PanelHeader>
          <PanelBody>
            <Grid>
              <Row>
                <Col xs={12}>

                  <div id={'calculator'} ref={ref => this.componentRef = ref}>
                    <p className="title print">Neofect Cost Calculator</p>
                    <div className="wrap">
                      <Tabs>
                        <div name="Product based" body="Facility lends products to patients">

                          {/* set price & number */}
                          <div className="inputs">
                            <div className="input--wrap">
                              <p className="input--title">Product Price</p>
                              <div className="input--text price">
                                <p className="print">$ {form.productPrice}</p>
                                <input
                                  type="number"
                                  name={'productPrice'}
                                  value={form.productPrice}
                                  onChange={this.changeForm}
                                />
                              </div>
                            </div>

                            <div className="input--wrap">
                              <p className="input--title">Product Qnty</p>
                              <div className="input--number">
                                <input
                                  type="number"
                                  name={'productQnty'}
                                  value={form.productQnty}
                                  onChange={this.changeForm}
                                />

                                <div className="input--btns">
                                  <button
                                    type={'button'}
                                    name={'productQnty'}
                                    onClick={this.increase}
                                  />
                                  <button
                                    type={'button'}
                                    name={'productQnty'}
                                    onClick={this.decrease}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="input--wrap">
                              <p className="input--title">Number of Patients</p>
                              <div className="input--number">
                                <input
                                  type="number"
                                  name={'numberOfPatients'}
                                  value={form.numberOfPatients}
                                  onChange={this.changeForm}
                                />

                                <div className="input--btns">
                                  <button
                                    type={'button'}
                                    name={'numberOfPatients'}
                                    onClick={this.increase}
                                  />
                                  <button
                                    type={'button'}
                                    name={'numberOfPatients'}
                                    onClick={this.decrease}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="input--wrap">
                              <p className="input--title">pt / Patient / Month</p>
                              <div className="input--number">
                                <input
                                  type="number"
                                  name={'pt'}
                                  value={form.pt}
                                  onChange={this.changeForm}
                                />

                                <div className="input--btns">
                                  <button type={'button'} name={'pt'} onClick={this.increase} />
                                  <button type={'button'} name={'pt'} onClick={this.decrease} />
                                </div>
                              </div>
                            </div>
                          </div>


                          {/* item price */}
                          <div className="box--itemPrice">
                            <table className="table type01">
                              <thead>
                                <tr>
                                  <th>Item</th>
                                  <th>Income</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    <p className="title">
                                      Weekly Telehealth Assessment/ Management (Non-physician) per
                                      month
                                    </p>

                                    <p className="body">
                                      <span className="primary">${item01.price.toFixed(2)}</span> (<span
                                      className="bold"
                                    >{item01.code}</span><span
                                      className="orange bold"
                                    >*</span> Non Physician Online Assessment & Management 5-10
                                      mins) <span
                                      className="primary"
                                    >x {form.pt}</span> (Number of pt per
                                      month) <span className="primary">x {form.numberOfPatients}</span> (Number
                                      of
                                      Patients)
                                    </p>
                                  </td>
                                  <td>
                                    <span className="primary">${(item01.price * form.pt * form.numberOfPatients).toFixed(2)}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <p className="title">
                                      Monthly Remote Monitoring (Non Physician)
                                    </p>

                                    <p className="body">
                                      <span className="primary">${item02.price.toFixed(2)}</span> (<span
                                      className="bold"
                                    >{item02.code}</span><span
                                      className="orange bold"
                                    >**</span> Non Physician Online Assessment & Management 5-10
                                      mins) <span
                                      className="primary"
                                    >x {form.numberOfPatients}</span> (Number of Patients)
                                    </p>
                                  </td>
                                  <td>
                                    <span className="primary">${(item02.price * form.numberOfPatients).toFixed(2)}</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            <div className="result">
                              <div className="explain">
                                <p className="text">
                                  <span className="primary bold">*</span>assumes 21+ mins per
                                  patient/week
                                </p>
                                <p className="text">
                                  <span className="primary bold">**</span>medicare rate, national
                                  average
                                </p>
                                <p className="text">
                                  <strong>PT Code 99454</strong> requires at least 16 days of device
                                  readings submitted by the patient within the 30-day period.
                                </p>
                                <p className="text">
                                  <strong>99545:</strong> The device used in the program must be a
                                  home-use medical device as defined by the FDA.
                                </p>
                              </div>

                              <p className="price">
                                Total Income per
                                month: <span className="primary bold">${totalPrice.toFixed(2)}</span>
                              </p>
                            </div>
                          </div>


                          {/* Payer and Patient per month */}
                          <div className="box--payer">
                            <p className="title">Payer and Patient per month</p>

                            <div className="info">
                              <p className="info__title">
                                Reimbursed by payer
                                ................................................................
                              </p>
                              <div className="info__body">
                                <div className="fragment">
                                  <p className="body">Monthly Inflow Estimate <span>(80% of
                                    allowable, Medicare,
                                    Ntl Average)</span></p>
                                  <p className="price">
                                    ${(totalPrice * 0.8).toFixed(2)}
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="info">
                              <p className="info__title">
                                Collected by clinic
                                .....................................................................
                              </p>
                              <div className="info__body">
                                <div className="fragment">
                                  <p className="body">Patient Out of Pocket <span>(Does not account
                                    for
                                    deductibles, etc)</span></p>
                                  <p className="price">
                                    ${(totalPrice - (totalPrice * 0.8)).toFixed(2)}
                                  </p>
                                </div>

                                <div className="fragment">
                                  <p className="body point">Total Payer and Patient per month:</p>
                                  <p className="price bold">
                                    ${totalPrice.toFixed(2)}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>


                          {/* Breakeven Point */}
                          <div className="box--breakevent">
                            <p className="title bold">Breakeven
                              Point: <span className="bold primary">{breakEven.point} months</span>
                            </p>

                            <table className="table type02">
                              <thead>
                                <tr>
                                  <th>Month</th>
                                  <th>x Payer and Patient per month</th>
                                  <th>ROI</th>
                                </tr>
                              </thead>
                              <tbody>
                                {breakEven.items}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div
                          name="Only uses TeleRehab"
                          body="Facility only uses TeleRehab software"
                        >
                          {/* set price & number */}
                          <div className="inputs">
                            <div className="input--wrap">
                              <p className="input--title">Number of Patients</p>
                              <div className="input--number">
                                <input
                                  type="number"
                                  name={'numberOfPatients'}
                                  value={form.numberOfPatients}
                                  onChange={this.changeForm}
                                />

                                <div className="input--btns">
                                  <button
                                    type={'button'}
                                    name={'numberOfPatients'}
                                    onClick={this.increase}
                                  />
                                  <button
                                    type={'button'}
                                    name={'numberOfPatients'}
                                    onClick={this.decrease}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="input--wrap">
                              <p className="input--title">pt / Patient / Month </p>
                              <div className="input--number">
                                <input
                                  type="number"
                                  name={'pt'}
                                  value={form.pt}
                                  onChange={this.changeForm}
                                />

                                <div className="input--btns">
                                  <button type={'button'} name={'pt'} onClick={this.increase} />
                                  <button type={'button'} name={'pt'} onClick={this.decrease} />
                                </div>
                              </div>
                            </div>
                          </div>


                          {/* item price */}
                          <div className="box--itemPrice">
                            <table className="table type01">
                              <thead>
                                <tr>
                                  <th>Item</th>
                                  <th>Income</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    <p className="title">
                                      Weekly Telehealth Assessment/ Management (Non-physician) per
                                      pt
                                    </p>

                                    <p className="body">
                                      <span className="primary">${item01.price.toFixed(2)}</span> (<span
                                      className="bold"
                                    >{item01.code}</span><span
                                      className="orange bold"
                                    >*</span> Non Physician Online Assessment & Management 5-10
                                      mins) <span
                                      className="primary"
                                    >x {form.pt}</span> (Number of pt per month)
                                    </p>
                                  </td>
                                  <td>
                                    <span className="primary">${(item01.price * form.pt).toFixed(2)}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <p className="title">
                                      Monthly Remote Monitoring (Non Physician)
                                    </p>

                                    <p className="body">
                                      <span className="primary">${item02.price.toFixed(2)}</span> (<span
                                      className="bold"
                                    >{item02.code}</span><span
                                      className="orange bold"
                                    >**</span> Non Physician Online Assessment & Management 5-10
                                      mins) <span
                                      className="primary"
                                    >x {form.numberOfPatients}</span> (Number of Patients)
                                    </p>
                                  </td>
                                  <td>
                                    <span className="primary">${(item02.price * form.numberOfPatients).toFixed(2)}</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            <div className="result">
                              <div className="explain">
                                <p className="text">
                                  <span className="primary bold">*</span>assumes 21+ mins per
                                  patient/week
                                </p>
                                <p className="text">
                                  <span className="primary bold">**</span>medicare rate, national
                                  average
                                </p>
                                <p className="text">
                                  <strong>PT Code 99454</strong> requires at least 16 days of device
                                  readings submitted by the patient within the 30-day period.
                                </p>
                                <p className="text">
                                  <strong>99545:</strong> The device used in the program must be a
                                  home-use medical device as defined by the FDA.
                                </p>
                              </div>

                              <p className="price">
                                Total Income per
                                month: <span className="primary bold">${totalPrice.toFixed(2)}</span>
                              </p>
                            </div>
                          </div>


                          {/* Payer and Partient per month */}
                          <div className="box--payer">
                            <p className="title">Payer and Patient per month</p>

                            <div className="info">
                              <p className="info__title">
                                Reimbursed by payer
                                ................................................................
                              </p>
                              <div className="info__body">
                                <div className="fragment">
                                  <p className="body">Monthly Inflow Estimate <span>(80% of
                                    allowable, Medicare,
                                    Ntl Average)</span></p>
                                  <p className="price">
                                    ${(totalPrice * 0.8).toFixed(2)}
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="info">
                              <p className="info__title">
                                Collected by clinic
                                .....................................................................
                              </p>
                              <div className="info__body">
                                <div className="fragment">
                                  <p className="body">Patient Out of Pocket <span>(Does not account
                                    for
                                    deductibles, etc)</span></p>
                                  <p className="price">
                                    ${(totalPrice - (totalPrice * 0.8)).toFixed(2)}
                                  </p>
                                </div>

                                <div className="fragment">
                                  <p className="body">Total Payer and Patient per month:</p>
                                  <p className="price bold">
                                    ${totalPrice.toFixed(2)}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tabs>

                      <div className="align--right">
                        <ReactToPrint
                          content={() => this.componentRef}
                          trigger={() => <button className="btn--big">Export PDF</button>}
                        >
                        </ReactToPrint>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Grid>
          </PanelBody>
        </Panel>
      </PanelContainer>
    );
  }
}

export default Calculator;



// WEBPACK FOOTER //
// ./src/routes/calculator/Calculator.js